import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { apiTags } from "./tags"
import { performLogoutActions } from "store/commonActions"
const baseUrl = process.env.REACT_APP_API_URL
// jwt
export const api = createApi({
  reducerPath: "api",
  tagTypes: Object.values(apiTags),
  baseQuery: async (args, WebApi, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: baseUrl,
      prepareHeaders: async (headers, { getState, endpoint }) => {
        const state = getState()
        const token = state.user?.jwt
        if (token) {
          headers.set("Authorization", `Bearer ${token}`)
        }

        return headers
      },
    })

    let result = await baseQuery(args, WebApi, extraOptions)
    if (result?.error?.status === 401) {
      performLogoutActions(WebApi.dispatch, true)
    }

    if (result?.error?.status === 403) {
      location.href = "/forbidden"
    }

    return result
  },
  endpoints: (builder) => ({}),
})

export default api
